<template>
  <v-flex sm12 md12 lg12>
    <v-snackbar
      ref="snackbar"
      :value="snackbar"
      :color="component.httpStatus == 200 ? 'green' : 'red'"
      :timeout="component.httpStatus == 200 ? 2000 : 0"
      :vertical="false"
    >
      {{ component.message }}
      <v-btn dark flat @click="snackbar = false">Close</v-btn>
    </v-snackbar>
  </v-flex>
</template>
<script>
export default {
  name: 'MessageAlert',
  props: {
    component: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      snackbar: false,
    };
  },
  computed: {
    // snackbar: function() {
    //   //   if (this.hide) return false;
    //   //   if (this.component.httpStatus !== 0) return true;
    //   if (this.component.httpStatus !== 0) return true;
    //   else return false;
    // },
    submitted: function () {
      if (this.component.httpStatus === 200) {
        return 'success';
      } else return 'error';
    },
  },
  watch: {
    component: function () {
      if (this.component.httpStatus !== 0) this.snackbar = true;
      else this.snackbar = false;
    },
  },
  mounted() {},
};
</script>
